module.exports = __webpack_public_path__ + "img/2.1932d3ce.jpg";